import ArticleSlider from './article-slider';
import SocialShare from './social-share';
import VgtrkScrollTrack from './scroll-track';
import articleTemplate from '../../pug/article.pug';
import lozad from 'lozad';
import LazyImages from './lazy-images';
import PlayerStarter from './player-starter';

const $body       = document.body;
const forbiddenID = window.articleId;

let historyCounter;

const afterArticleSlotIDs = [
    288, 289, 290
];
let afterArticleCounter   = 0;

// let $sticky    = document.querySelector('.sticky__content');
let $place;
let $articles;
let $players   = [];
let $current;
let firstUrl;
let canLoad;
let current;
let articleIDs = null;

const init = (instance) => {
    let articleID;
    let $player;
    let startFlag = true;

    historyCounter = 0;

    $place = document.querySelector('.content__inner');

    $articles  = $place.querySelectorAll('article');
    $current   = $articles[0];
    articleID  = $current.getAttribute('data-id');
    firstUrl   = {
        full: window.location.href,
        path: window.location.pathname
    };
    canLoad    = true;
    current    = 0;
    articleIDs = articleIDs || getIDs(articleID)
        // .then((json => json.success ? articleIDs = json.data.filter(id => id !== forbiddenID) : articleIDs = []))
        .then(json => json.length ? articleIDs = json.filter(id => id !== forbiddenID) : articleIDs = []);

    $player = window.frames[`vgtrk_player_${ articleID }`];
    $place.classList.add('loading');

    let scrollTrack = new VgtrkScrollTrack($current, 'article')
    if ('mediaScope' in window) {
        mediaScope.hit({
            typ:  1,
            idlc: +articleID,
            urlc: window.location.href,
            ver:  0,
            type: 4
        })
    }

    // Плеер автостар  блок 1
    // if ($player) {
    //     $players.push({
    //         frame:     $player,
    //         $el:       document.querySelector(`[name=vgtrk_player_${articleID}]`),
    //         isPlaying: true
    //     });
    // }

    window.addEventListener('scroll', () => {
        watch(instance)
    });
    window.addEventListener('resize', () => {
        watch(instance)
    });
    window.addEventListener('popstate', () => {
        history.go(-historyCounter);
    });
    window.addEventListener('message', (event) => {
        if (typeof window.frames['mini_player_iframe'] !== 'undefined' && (window.frames['mini_player_iframe'] === event.source)) {

            let data = {};
            try {
                data = JSON.parse(event.data);
            } catch (e) {
            }
            if (data.message !== 'undefined' && data.message === 'started' && startFlag) {
                $players[0].frame.postMessage('play', '*');
                startFlag = false;
            }

        }
    });
};

const watch = (instance) => {
    let scrollTop  = window.scrollTop || window.pageYOffset;
    let breakpoint = $body.offsetHeight - window.innerHeight * 4;

    // Автостарт пллере при видимости. блок 2
    // [...$players].forEach($player => {
    //     let windowHeight = window.innerHeight;
    //     let offsetTop    = $player.$el.getBoundingClientRect().top;
    //     let offsetBottom = $player.$el.getBoundingClientRect().bottom;
    //     let height50=(offsetBottom-offsetTop)/2;
    //     if (offsetTop <= (windowHeight-height50) && offsetBottom >= height50) {
    //         if (!$player.isPlaying) {
    //             $player.frame.postMessage('play', '*');
    //             $player.isPlaying = true;
    //         }
    //     } else {
    //         if ($player.isPlaying) {
    //             $player.frame.postMessage('pause', '*');
    //             $player.isPlaying = false;
    //             window.frames['mini_player_iframe'].postMessage('play', '*');
    //         }
    //     }
    // });

    [ ...$articles ].forEach($article => {
        let offsetTop    = $article.getBoundingClientRect().top;
        let offsetBottom = $article.getBoundingClientRect().bottom;

        if (offsetTop <= 0 && offsetBottom >= 0) {
            if ($article !== $current) {
                let id      = $article.id ? $article.id.split('-')[1] : null;
                let url     = id ? $article.getAttribute('data-url') : firstUrl.path;
                let title   = $article.querySelector('.article__title').innerText;
                let datePub = new Date($article.getAttribute('data-datepub'));

                $current = $article;

                history.pushState(id, 'Article', url);

                $('title').text(title);

                // datePub = datePub.getTime()/1000;

                if ('mediaScope' in window) {
                    mediaScope.hit({
                        typ:  1,
                        idlc: id,
                        urlc: url,
                        ver:  0,
                        type: 4
                    })
                }

                if ('ym' in window) {
                    window.yaParams = {'tagTitle': tagTitle, ' subsite ': subsite};
                    ym(21374125, 'params', window.yaParams || {});
                    // ym(21374125, 'hit', url);
                    // ym(55382026, 'hit', url);
                    // ym(21374125,'reachGoal','depth_test');
                }

                // gtag('config', 'UA-4795608-3', {
                //     'page_title': title,
                //     'page_path':  url
                // })
                // gtag('event', 'page_view', { 'send_to': 'UA-4795608-3' });
                // gtag('event', 'scroll_to_new', {
                //     event_category: 'pageview',
                //     event_label:    'article'
                // });

                historyCounter++;
            }
        }
    });

    if (scrollTop >= breakpoint && canLoad && current < articleIDs.length) {
        loadMore();
    }
};

const loadMore = () => {

    canLoad = false;

    getArticle(articleIDs[current++])
        .then(json => {
            let $article,
                $player,
                $slider,
                $share,
                shareOptions,
                $slotStatic,
                $slotSticky,
                $slotAfter;
            let $wrapper = document.createElement('div');

            let article = {
                id:             json.data.id,
                title:          json.data.title,
                anons:          json.data.anons,
                body:           json.data.body,
                url:            json.data.url,
                datePub:        json.data.datePub,
                topic:          json.data.topic,
                routesToPages:  json.data.routesToPages,
                date:           getArticleDate(json.data),
                mediaCount:     getMediaCount(json.data),
                pictures:       getArticlePictures(json.data),
                videos:         getArticleVideos(json.data),
                tags:           getArticleTags(json.data),
                tagsData:       json.data.tagsData
            };

            article.body = article.body.replaceAll(' target="_blank"', '');
            article.body = article.body.replaceAll('<a ', '<a target="_blank"');

            $wrapper.innerHTML = articleTemplate({article});

            $article     = $wrapper.firstChild;
            $slider      = $article.querySelector('.article__slider_top');
            $share       = $article.querySelector('.ya-share2');
            shareOptions = {
                content: {
                    url:         `${ window.location.origin }/article/${ article.id }`,
                    title:       article.title,
                    description: article.anons,
                    image:       article.pictures && article.pictures.length ? article.pictures[0].url.xw : '' // TODO: Default share image
                }
            };

            $place.appendChild($article);

            $slotStatic = $article.querySelector('.slot--article .slot__container--static');
            $slotSticky = $article.querySelector('.slot--article .slot__container--sticky');
            $slotAfter  = $article.querySelector('.slot--after-article .slot__container--static');
            $player     = window.frames[`vgtrk_player_${ article.id }`];

            let slider      = new ArticleSlider($slider);
            let share       = new SocialShare($article.querySelector('.share'), `${ window.location.origin }${ article.url }`, article.title);
            let scrollTrack = new VgtrkScrollTrack($article, 'article')

            if ($player) {
                // $player.frame.postMessage('pause', '*');
                $players.push({
                    frame:     $player,
                    $el:       document.querySelector(`[name=vgtrk_player_${ article.id }]`),
                    isPlaying: true
                });
            }

            new LazyImages($article.querySelectorAll('img.vgtrk-lazy'));
            new PlayerStarter();

            canLoad   = true;
            $articles = $place.querySelectorAll('article');

            afterArticleCounter++;

            if (afterArticleCounter > afterArticleSlotIDs.length - 1) {
                afterArticleCounter = 0;
            }

            if ('twttr' in window) {
                twttr.widgets.load()
            }

            if (current === articleIDs.length - 1) {
                $place.classList.remove('loading');
            }

            fetch('/js/slot_284.html')
                .then(response => response.text())
                .then(html => $($slotStatic).append(html.replace(/(adfox_)(\d.+?)/ig, '$1' + article.id + '284')));

            fetch('/js/slot_285.html')
                .then(response => response.text())
                .then(html => $($slotSticky).append(html.replace(/(adfox_)(\d.+?)/ig, '$1' + article.id + '285')));

            if (current == 0) afterArticleCounter = 0
            if (current == 1) afterArticleCounter = 1
            if (current > 1) afterArticleCounter = 2

            fetch(`/js/slot_${ afterArticleSlotIDs[afterArticleCounter] }.html`)
                .then(response => response.text())
                .then(html => {

                    if (html.match(/(adfox_)(\d.+?)/ig)) {
                        html = html.replace(/(adfox_)(\d.+?)/ig, '$1' + article.id + '288');
                    }

                    if (html.match(/\.widget-container/ig)) {
                        html = html.replace(/\.widget-container/ig, '#widget-id-' + article.id);
                        html = html.replace(/\.widget__header/ig, '#widget-id-' + article.id + ' .widget__header');
                        html = html.replace('class="widget-container"', 'id="widget-id-' + article.id + '" class="widget-container"')

                        $(html).eq('.widget-container').attr('id', 'widget-id-' + article.id);

                    }
                    $($slotAfter).append(html)
                });

        })
        .catch(err => {
            console.log(err);
        });
};

const getIDs = (id) => fetch(`https://www.vesti.ru/recs/np/article/${ id }`)
    .then(response => response.json());

const getArticle = id => fetch(`/api/article/${ id }`)
    .then(response => response.json());

const getMediaCount = article => {
    let videoCount    = article.videos && article.videos.length;
    let picturesCount = article.pictures && article.pictures.length;

    return videoCount + picturesCount;
};

const getArticleDate = article => {
    const MONTHS = [ 'Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря' ];

    let [ date, time ]              = article.datePub.split(' ');
    let [ day, month, year ]        = date.split('-');
    let [ hours, minutes, seconds ] = time.split(':');

    return {
        date: `${ day } ${ MONTHS[+month - 1].toLowerCase() } ${ year }`,
        time: `${ hours }:${ minutes }`
    }

};

const getArticlePictures = article => article.pictures && article.pictures.length
                                      ? article.pictures.map(picture => ({
        url:   {
            xw: picture.urls.xw,
            nw: picture.urls.nw
        },
        link:  picture.sourceLink,
        title: picture.sourceTitle,
        alt:   picture.alt
    }))
                                      : [];

const getArticleVideos = article => article.videos && article.videos.length
                                    ? article.videos.map(video => ({
        title:   video.title,
        source:  video.playerUrl,
        picture: {
            url:   {
                xw: video.picture.urls.xw,
                nw: video.picture.urls.nw
            },
            title: video.picture.sourceTitle,
            alt:   video.picture.alt
        }
    }))
                                    : [];

const getArticleTags = article => article.tags && article.tags.length
                                  ? article.tags.map(tag => ({
        title: tag,
        url:   `/tag/${ encodeURI(tag) }`
    }))
                                  : [];

export default class InfinityScroll {
    constructor() {
        return window.location.pathname.match('/article/') ? init(this) : {};
    }

}
